import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeExtensao',
})
export class RemoveExtensaoPipe implements PipeTransform {

  transform(value: string): string {
    // Verifique se o valor não é nulo ou indefinido
    if (value == null) {
      return '';
    }

    // Use o método lastIndexOf para encontrar o último ponto na string (indicando a extensão)
    const lastIndex = value.lastIndexOf('.');
    
    // Se encontrou um ponto, retorne a parte da string antes do ponto; caso contrário, retorne o valor original.
    return lastIndex !== -1 ? value.substring(0, lastIndex) : value;
  }

}
